const resolveCRMSyncs = <P = unknown>({ rawVal = [] }) => {
  if (!rawVal.length) return [];

  return rawVal.map(({ crmName = '', marketoName = '' }) => ({
    crmName: crmName?.trim(),
    marketoName: marketoName?.trim(),
  })) as unknown as P[];
};

export default resolveCRMSyncs;
